<template>
  <div class="select">
    <select
      :id="`${field.name}-field`"
      :name="field.name"
      @change="updateFormData"
    >
      <option>Select One</option>
      <option v-for="(option, index) in field.options" :key="index" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateFormData(e) {
      const field = {
        name: e.target.name,
        value: e.target.value,
      };
      this.$store.dispatch('addToSubmission', field);
    },
  },
  mounted() {
    const field = {
      name: this.field.name,
      value: null,
    };
    this.$store.dispatch('addToSubmission', field);
  },
};
</script>
